import { makeObservable, observable, runInAction, action, makeAutoObservable } from 'mobx';
import { VatServices } from '../services/vatServices';
import i18n from 'i18next';
import { toast } from "react-toastify";
import { makePersistable, stopPersisting } from 'mobx-persist-store';


export default class VatStore {    

    
  rootStore;
  vats = [];
    vat = {};
    config = {
        sort: [],
        filter: [],
        size: {}
    };

  constructor(rootStore) {
      this.rootStore = rootStore;

      makeObservable(this, {
          config: observable,
          setConfig: action,

          getAllWithOptions:action,
          vats: observable,
          vat: observable,
          //getAll: action,
          //get:action,
          reset: action,
          save: action,
          remove: action,
          duplicate:action
      });

      makePersistable(this, { name: 'vatStore', properties: ['config'], storage: window.localStorage });

    }       

    remove = async (id) => {
        try {
            const data = await VatServices.delete(id);
            runInAction(() => { toast.success(`${i18n.t("wasDeleted", { entity: i18n.t("vat") })}`);});
        } catch (error) {
            runInAction(() => {/*toast.error(i18n.t("errorOcurred"));*/});
        }
    }

    duplicate = async (id) => {
        try {
            const data = await VatServices.duplicate(id);
            runInAction(() => { toast.success(`${i18n.t("wasDuplicated", { entity: i18n.t("vat") })}`); });
        } catch (error) {
            runInAction(() => {/*toast.error(i18n.t("errorOcurred"));*/ });
        }
    }

    save = async (entity, onSuccess) => {
        if (entity.id) {
            try {
                const data = await VatServices.update(entity.id, entity);
                runInAction(() => {
                    if (onSuccess) { onSuccess() };
                    this.reset();
                    toast.success(`${i18n.t("wasUpdated", { entity: i18n.t("vat") })}`);
                });
            } catch (error) {}
        } else {
            try {
                const data = await VatServices.create(entity);
                runInAction(() => {
                    if (onSuccess) { onSuccess() };
                    toast.success(`${i18n.t("wasCreated", { entity: i18n.t("vat") })}`);
                    this.reset();                    
                });
            } catch (error) {}
        }
    };

    reset = () => {        
        runInAction(() => this.vat = {});
    }
   
    setConfig = (prop, c) => {        
        this.config[prop] = c;
    }

    getAllWithOptions = async (options/*page, filter, sort*/) => {
        try {
            const data = await VatServices.getAllWithOptions(options/*{ page: page, filter: filter, sort: sort }*/);
            runInAction(() => {
                this.vats = data;
            })
        }
        catch (error) {
            runInAction(() => {
                this.vats = [];
            });
        }
    }

   /* getAll = async (page, filter, sort) => {
        try {            
            const data = await CurrencyServices.getAll({ page: page, filter: filter, sort: sort });
            runInAction(() => {this.currencies = data;})
        }
        catch (error) {
            runInAction(() => {this.currencies = [];});
        }
    }    */

    getById = async (id) => {
        try {
            const data = await VatServices.getById(id);
            runInAction(() => { this.vat = data;});
        } catch (error) {
            runInAction(() => { this.vat = {};})
        }
    };
}